import React, { ReactNode } from "react";
import styles from "./CheckoutFormGroupHeader.module.scss";

const CheckoutFormGroupHeader = ({
    title,
    iconJSX,
}: {
    title: string;
    iconJSX: ReactNode;
}) => {
    return (
        <div className={styles.Wrapper}>
            {iconJSX}
            <div className={styles.TitleText}>{title}</div>
        </div>
    );
};

export default CheckoutFormGroupHeader;
